import React from 'react';
import classnames from 'classnames';
import IconArrowUp from '@wix/da-ds/pkg/Icons/ArrowUp';
import IconArrowDown from '@wix/da-ds/pkg/Icons/ArrowDown';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './NumberControls.scss';
var NumberControls = function (_a) {
    var className = _a.className, onIncrement = _a.onIncrement, onDecrement = _a.onDecrement;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("span", { onClick: onIncrement, className: s['button'] },
            React.createElement(IconArrowUp, { size: IconSize.TINY })),
        React.createElement("span", { onClick: onDecrement, className: s['button'] },
            React.createElement(IconArrowDown, { size: IconSize.TINY }))));
};
NumberControls.displayName = 'NumberControls';
export default NumberControls;
//# sourceMappingURL=NumberControls.js.map